/**
 * 设置屏幕显示模式
 * 宽窄屏
 */
export const setWindowMode = () => {
    const windowWidth = document.body.offsetWidth;

    // 屏幕宽度大于1515px认为是宽屏
    if (windowWidth > 1515) {
        return 'wide';
    }

    return 'narrow';
};
